<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-10">
        <h1>{{title}}</h1>
      </div>
      <div class="col-12">
        <div class="float-left col-10 p-0">
          <input type="text" class="form-control form-control-sm input-custom" (keyup.enter)="findPermitDetailByLP(search)"
            placeholder="Search" [(ngModel)]="search" />
        </div>
        <div class="float-left col-1 p-0 pl-2">
          <input class="btn btn-sm btn-success w-100" type="button" (click)="findPermitDetailByLP(search)" value="Search"/>
        </div>
        <div class="float-left col-1 p-0 pl-2">
          <button class="btn btn-sm btn-success w-100" type="button" (click)="excelSheetDownload()"><i class="fa fa-file-excel mr-1" aria-hidden="true"></i>Export</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <div class="table-responsive db-block" style="height: auto !important;">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{title}}</span>
        <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
          <ng-container matColumnDef="data.numberPlate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>License Plate</th>
            <td mat-cell *matCellDef="let element">{{element.data.numberPlate}}</td>
          </ng-container>
  
          <ng-container matColumnDef="data.zoneNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
            <td mat-cell *matCellDef="let element">{{element.data.zoneNumber}}</td>  
          </ng-container>
  
          <ng-container matColumnDef="data.startTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
            <td mat-cell *matCellDef="let element">{{element.data.startTime | date:'y-MM-dd HH:mm:ss.SSS'}}</td>
          </ng-container>
  
          <ng-container matColumnDef="data.endTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
            <td mat-cell *matCellDef="let element">{{element.data.endTime | date:'y-MM-dd HH:mm:ss.SSS'}}</td>
          </ng-container>
  
          <ng-container matColumnDef="data.paymentServiceName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Name</th>
            <td mat-cell *matCellDef="let element"> {{element.data.paymentServiceName}} </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
